const getTimestamp = () => {
  return new Date();
};

const _getNullValueForField = (template, field) => {
  switch (template[field].type) {
    case "string":
      return "";
    case "object":
      return {};
    case "number":
      return 0;
    default:
      return null;
  }
}

const getTemplate = (template) => {
  const data = {}
  for (const field in template) {
    if (template[field].required)
      data[field] = _getNullValueForField(template, field);
    else
      data[field] = template[field].default;
  }

  return data;
}

const getDataForRefs = refs => {
  const items = [];
  if (!refs.docs.length) {
    return items;
  }

  refs.docs.forEach(doc => {
    let item = null;
    if (doc.exists) {
      item = doc.data();
      if (!item.uid) item.uid = doc.id;
    }

    if (item !== null) items.push(item);
  });

  return items;
};

const updateModel = (model, template) => {
  for(const field in template) {
    if (!field in model) {
        if(template[field].required) {
          model[field] = _getNullValueForField(template, field)
        }else {
          model[field] = field.default
        }
    }
  }
  return model;
}

export default {
  getTimestamp,
  getTemplate,
  getDataForRefs,
  updateModel
};
